import React, { useContext } from "react";
import RichText from "myplan/components/RichText";
import { FurnitureContext } from "myplan/utils/furniture";
import DrawerButton from "myplan/components/DrawerButton";
import { Container, Scroll, Header } from "./styles";

const PrivacyPolicy = ({ navigation }) => {
    const furniture = useContext(FurnitureContext);

    return (
        <Container>
            <DrawerButton
                onGoBack={() => {
                    navigation.goBack();
                }}
            />

            <Scroll>
                <Header type="h3">{furniture.privacyPolicyTitle}</Header>
                {/* <ImageContainer>
					<Hero />
				</ImageContainer> */}
                <RichText doc={furniture.privacyPolicy} />
            </Scroll>
        </Container>
    );
};

export default PrivacyPolicy;
